// Code generated by Slice Machine. DO NOT EDIT.
// @ts-nocheck

import {defineSliceZoneComponents} from '@prismicio/vue';

import AddOn from './AddOn/index.vue';
import BenefitsSlice from './BenefitsSlice/index.vue';
import Calendly from './Calendly/index.vue';
import Charts from './Charts/index.vue';
import Comparison from './Comparison/index.vue';
import ComparisonSection from './ComparisonSection/index.vue';
import ConsultantProfiles from './ConsultantProfiles/index.vue';
import ContentSlice from './ContentSlice/index.vue';
import CookiePurpose from './CookiePurpose/index.vue';
import Criterias from './Criterias/index.vue';
import DemoPopup from './DemoPopup/index.vue';
import HeroSlice from './HeroSlice/index.vue';
import HeroStrategy from './HeroStrategy/index.vue';
import HeroWithShapes from './HeroWithShapes/index.vue';
import Highlight from './Highlight/index.vue';
import InvitationReferencing from './InvitationReferencing/index.vue';
import JobCategories from './JobCategories/index.vue';
import JobPageConfig from './JobPageConfig/index.vue';
import JobsFamilySlice from './JobsFamilySlice/index.vue';
import KeyFigures from './KeyFigures/index.vue';
import Partners from './Partners/index.vue';
import Plans from './Plans/index.vue';
import ProductContent from './ProductContent/index.vue';
import ProductDemo from './ProductDemo/index.vue';
import ProductFeaturedText from './ProductFeaturedText/index.vue';
import ProductHero from './ProductHero/index.vue';
import ProductVideo from './ProductVideo/index.vue';
import ProofPoints from './ProofPoints/index.vue';
import Quotation from './Quotation/index.vue';
import ResourcesBloc from './ResourcesBloc/index.vue';
import RichContent from './RichContent/index.vue';
import SearchSlice from './SearchSlice/index.vue';
import Skills from './Skills/index.vue';
import SpacerSlice from './SpacerSlice/index.vue';
import TagDescription from './TagDescription/index.vue';
import TestimonialsSlice from './TestimonialsSlice/index.vue';
import Trustpilot from './Trustpilot/index.vue';

export const components = defineSliceZoneComponents({
    add_on: AddOn,
    benefits_slice: BenefitsSlice,
    calendly: Calendly,
    charts: Charts,
    comparison: Comparison,
    comparison_section: ComparisonSection,
    consultant_profiles: ConsultantProfiles,
    content_slice: ContentSlice,
    cookie_purpose: CookiePurpose,
    criterias: Criterias,
    demo_popup: DemoPopup,
    hero_slice: HeroSlice,
    hero_strategy: HeroStrategy,
    hero_with_shapes: HeroWithShapes,
    highlight: Highlight,
    invitation_referencing: InvitationReferencing,
    job_categories: JobCategories,
    job_page_config: JobPageConfig,
    jobs_family_slice: JobsFamilySlice,
    key_figures: KeyFigures,
    partners: Partners,
    plans: Plans,
    product_content: ProductContent,
    product_demo: ProductDemo,
    product_featured_text: ProductFeaturedText,
    product_hero: ProductHero,
    product_video: ProductVideo,
    proof_points: ProofPoints,
    quotation: Quotation,
    resources_bloc: ResourcesBloc,
    rich_content: RichContent,
    search_slice: SearchSlice,
    skills: Skills,
    spacer_slice: SpacerSlice,
    tag_description: TagDescription,
    testimonials_slice: TestimonialsSlice,
    trustpilot: Trustpilot,
});
